import React from 'react';
import { useCurrentLanguage } from 'tradera-lang/translate';
import './start-page-hero-trustmark.scss';

export const StartPageHeroTrustmark = () => {
    const { language } = useCurrentLanguage();
    const trustmarkLanguages = ['da', 'de'];

    return trustmarkLanguages.includes(language) ? (
        <div className="trusted-shops-container">
            <img
                className="trustmark"
                src="/static/images/hero/trustmark.svg"
                alt="Trusted shops"
            />
        </div>
    ) : null;
};
